import React from 'react';

interface TaglineColorPickersProps {
    bg: string;
    setBg: (val: string) => void;
    text1: string;
    setText1: (val: string) => void;
    text2: string;
    setText2: (val: string) => void;
    setHighlightedElement: (element: string | null) => void;
    disabled: boolean;
}

const TaglineColorPickers: React.FC<TaglineColorPickersProps> = ({
    bg,
    setBg,
    text1,
    setText1,
    text2,
    setText2,
    setHighlightedElement,
    disabled
}) => {
    const [activeFocus, setActiveFocus] = React.useState<string | null>(null);

    const handleReceiveFocus = (element: string) => {
        setActiveFocus(element);
        setHighlightedElement(element);
    };

    const handleMouseEnter = (element: string) => {
        if (activeFocus && activeFocus !== element) {
            setActiveFocus(null);
        }
        setHighlightedElement(element);
    };

    const handleMouseLeave = () => {
        if (!activeFocus) {
            setHighlightedElement(null);
        }
    };

    return (
        <div className="tagline-input-wrapper">
            <p>
                <b>Tagline Colors</b>
                <span className="esl"> (Customize the appearance of the tagline bar components)</span>
            </p>
            <div className="color-input-wrapper-tagline">
                <label
                    className="color"
                    onMouseEnter={() => handleMouseEnter('background')}
                    onMouseLeave={handleMouseLeave}
                >
                    <p>Background</p>
                    <input
                        type="color"
                        value={bg}
                        onChange={(e) => setBg(e.target.value)}
                        disabled={disabled}
                        onFocus={() => handleReceiveFocus('background')}
                        onClick={() => handleReceiveFocus('background')}
                    />
                </label>
                <label
                    className="color"
                    onMouseEnter={() => handleMouseEnter('text1')}
                    onMouseLeave={handleMouseLeave}
                >
                    <p>Text 1</p>
                    <input
                        type="color"
                        value={text1}
                        onChange={(e) => setText1(e.target.value)}
                        disabled={disabled}
                        onFocus={() => handleReceiveFocus('text1')}
                        onClick={() => handleReceiveFocus('text1')}
                    />
                </label>
                <label
                    className="color"
                    onMouseEnter={() => handleMouseEnter('text2')}
                    onMouseLeave={handleMouseLeave}
                >
                    <p>Text 2</p>
                    <input
                        type="color"
                        value={text2}
                        onChange={(e) => setText2(e.target.value)}
                        disabled={disabled}
                        onFocus={() => handleReceiveFocus('text2')}
                        onClick={() => handleReceiveFocus('text2')}
                    />
                </label>
            </div>
        </div>
    );
};

export default TaglineColorPickers;
